import React from "react";
import { ArrowRight } from "lucide-react";
import { useQuote } from "../context/QuoteContext";

export default function MobileQuoteBar() {
  const { openQuote, open } = useQuote();
  if (open) return null;
  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 px-4 py-3 bg-white/95 backdrop-blur-md border-t border-[#0A1128]/10"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
    >
      <button
        onClick={() => openQuote()}
        data-testid="mobile-sticky-quote"
        className="w-full flex items-center justify-center gap-2 bg-[#1F6FEB] active:bg-[#1556B8] transition-colors text-white py-4 font-bold text-sm tracking-widest uppercase"
      >
        Request a Quote <ArrowRight size={18} />
      </button>
    </div>
  );
}
